import { useEffect, useRef, useState } from 'react';

export const useButtonIconVisibility = ({ heightOfOneLine }: { heightOfOneLine: number }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [shouldShowIcon, setShouldShowIcon] = useState(true);

  useEffect(() => {
    if (buttonRef.current) {
      const button = buttonRef.current;
      const rect = button.getBoundingClientRect();

      if (rect.height > heightOfOneLine) {
        setShouldShowIcon(false);
      }
    }
  }, []);

  return { buttonRef, shouldShowIcon };
};
